import { StyleAndSize } from '../ProductCard/ProductCard';

export class SwatchHelpers {
    private static readonly IMAGE_URL_PREFIX = 'https://item.tscimg.ca/TSC/';
    private static readonly IMAGE_URL_DELIMITER = '/0x0/';

    public static async isSwatchAvailable(source: string): Promise<boolean> {
        return new Promise((resolve, reject) => {
            try {
                const imgElement = document.createElement('img');
                imgElement.src = source;

                imgElement.addEventListener('load', () => {
                    resolve(true);
                });

                imgElement.addEventListener('error', (error) => {
                    reject('Failed to load');
                    //resolve(false);
                });
            } catch (e) {
                reject(e);
                //resolve(false);
            }
        });
    }

    public static getSwatchUrl(imageUrl: string, dimensionId: string): string {
        const [fst, snd] = imageUrl.split(SwatchHelpers.IMAGE_URL_DELIMITER);
        const [id] = snd.split('_');
        const link = `${fst}/${id}_${dimensionId}_SW.jpg`;
        return SwatchHelpers.IMAGE_URL_PREFIX + link;
    }

    public static async doSwatchesExist(AvailableSwatches: string[]): Promise<boolean> {
        if (Array.isArray(AvailableSwatches) && AvailableSwatches.length >= 1) {
            try {
                const result = await SwatchHelpers.isSwatchAvailable(
                    SwatchHelpers.IMAGE_URL_PREFIX + AvailableSwatches[0],
                );
                return result;
            } catch (error) {
                return false;
            }
        } else {
            return false;
        }
    }

    public static async areSwatchesOk(stylesArr: StyleAndSize[], imageUrl: string) {
        const promises = [];
        stylesArr.map((s) => {
            const source = SwatchHelpers.getSwatchUrl(imageUrl, s.DimensionId);
            promises.push(SwatchHelpers.isSwatchAvailable(source));
        });
        return Promise.all(promises);
    }
}
